import styled from 'styled-components';
import { breakpoints, pxToRem, colors, getTypography, shadows } from '@vfit/shared/themes';

export const Container = styled.article<{ shortCard?: boolean }>`
  background-color: ${colors.$ffffff};
  border-radius: ${pxToRem(6)};
  box-shadow: ${shadows.card_overlay};
  gap: ${pxToRem(16)};
  padding: ${pxToRem(20, 16)};
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  @media (min-width: ${breakpoints.tablet}) {
    ${({ shortCard }) => (shortCard ? 'width: 49%' : 'width:100%')};
  }
`;

export const Title = styled.h2`
  align-items: center;
  display: flex;
  margin: 0;
  ${getTypography('body1.bold')}
`;

export const ContentContainer = styled.section`
  flex: 1;
  display: flex;
  gap: ${pxToRem(16)};

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;
export const Content = styled.div`
  flex: 1;
`;
export const Description = styled.section`
  ${getTypography('body2.regular')}

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  p {
    :first-child {
      margin-top: 0;
    }

    :last-child {
      margin-bottom: 0;
    }
  }
`;

export const ImgWrapper = styled.div`
  flex-shrink: 0;
  height: ${pxToRem(48)};
  width: ${pxToRem(48)};
`;

